import React from 'react';
import { Route } from 'react-router-dom';
import Loader from './Loader';

const EventLoaderPlaceholder = () => {
  return <Route path="*" component={Loader} />;
};

export default EventLoaderPlaceholder;
